<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App',
  data () {
    return {
    }
  },
  methods: {
    handleSelect (key, keyPath) {
      this.$router.push({path: '/'})
    }
  },
  components: { }
}
</script>

<style>
html {
  background: #f6f6f8;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.el-header {
  position: relative;
  width: 100%;
  height: 60px;
}

.banner-width {
  height: 60px;
  width: 1080px;
}

@media only screen and (max-width: 1079px) {
  .banner-width {
    height: 60px;
    width: 720px;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue